<script>
  import Avatar from 'vue-avatar'

  export default {
    name: 'top-bar-user',

    components: {
      Avatar
    }
  }
</script>

<template>
  <b-nav-item-dropdown right no-caret>
    <template slot="button-content">
      <avatar username="Eli Perez" :size="26" background-color="#ffb300" color="#000000"></avatar>
    </template>
    <b-dropdown-item href="#">Profile</b-dropdown-item>
    <b-dropdown-divider/>
    <b-dropdown-item href="#">Sign Out</b-dropdown-item>
  </b-nav-item-dropdown>
</template>
